import { all, fork } from 'redux-saga/effects';
import watchUser from './UserSaga';
import watchRestaurant from './RestaurantSaga';

export default function* () {
  yield all([fork(watchUser), fork(watchRestaurant)]);
}
